import { render } from "./TwoFactorInvitation.vue?vue&type=template&id=e3e86c98"
import script from "./TwoFactorInvitation.vue?vue&type=script&lang=js"
export * from "./TwoFactorInvitation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__